import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import GlassNavbar from './components/GlassNavbar';
import CookieBanner from './components/CookieBanner';
import RequireRole from './routes/RequireRole';
import Home from './pages/Home';
import Gestion from './pages/Gestion';
import Tecnicos from './pages/Tecnicos';
import Ciudadania from './pages/Ciudadania';
import NfcRequest from './pages/NfcRequest';
import Ecoparque from './pages/Ecoparque';
import EcoparqueRegistro from './pages/EcoparqueRegistro';
import EcoparqueLogin from './pages/EcoparqueLogin';
import GestionEcoparque from './pages/GestionEcoparque';
import GestionEcoparqueDashboard from './pages/GestionEcoparqueDashboard';
import GestionResumen from './pages/GestionResumen';
import GestionLayout from './components/GestionLayout';
import ReportarIncidencia from './pages/ReportarIncidencia';

function AppLayout() {
  const location = useLocation();
  const isDashboard =
    location.pathname.startsWith('/gestion') ||
    location.pathname.startsWith('/tecnicos');
  // Update page title and meta on route change
  useEffect(() => {
    const titles = {
      '/': 'Cuidemos Los Alcázares® | Servicios de limpieza y recogida',
      '/gestion': 'Gestión Interna | Cuidemos Los Alcázares®',
      '/tecnicos': 'Técnicos Municipales | Cuidemos Los Alcázares®',
      '/ciudadania': 'Ciudadanía | Cuidemos Los Alcázares®',
    };
    document.title = titles[location.pathname] || titles['/'];
  }, [location.pathname]);

  return (
    <>
      {/* GlassNavbar only on non-dashboard routes */}
      {!isDashboard && <GlassNavbar />}

      {/* Cookie banner always visible */}
      <CookieBanner />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/gestion"
          element={
            <RequireRole role="gestion">
              <GestionLayout />
            </RequireRole>
          }
        >
          <Route index element={<GestionResumen />} />
          <Route path="incidencias" element={<Gestion />} />
          <Route path="ecoparque" element={<GestionEcoparqueDashboard />} />
          <Route path="ecoparque/registrar" element={<GestionEcoparque />} />
        </Route>
        <Route
          path="/tecnicos"
          element={
            <RequireRole role="tecnicos">
              <Tecnicos />
            </RequireRole>
          }
        />
        <Route path="/ciudadania" element={<Ciudadania />} />
        <Route path="/solicitar-nfc" element={<NfcRequest />} />
        <Route path="/ecoparque" element={<Ecoparque />} />
        <Route path="/ecoparque/registro" element={<EcoparqueRegistro />} />
        <Route path="/ecoparque/login" element={<EcoparqueLogin />} />
        <Route path="/reportar-incidencia" element={<ReportarIncidencia />} />
        <Route
          path="*"
          element={
            <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-[#FAFCFE]">
              <p className="font-display text-5xl text-[#0A2540]">404</p>
              <p className="text-[#6F8AA8]">Página no encontrada</p>
              <a href="/" className="rounded-full px-8 py-3 bg-[#0A2540] text-white text-sm hover:bg-[#1E5AA8] transition-colors">
                Volver al inicio
              </a>
            </div>
          }
        />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppLayout />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
